import type { FC, SVGProps } from "react";

/**
 * `magic-wand-04` — the glyph on the About generator's "Surprise me" button (Figma 1954:9516).
 *
 * Hand-drawn rather than exported: the Figma instance never had its icon swap applied, so the
 * node exports the component's default `heroicons-mini/plus`. This matches what the frame
 * actually renders. Heroicons has no wand, so there is nothing in the design library to reuse.
 */
export const MagicWandIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 4V2M15 16V14M8 9H10M20 9H22M17.8 11.8L19 13M17.8 6.2L19 5M3 21L12 12M12.2 6.2L11 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
